import type { FunctionComponent } from 'react';
import { useState } from 'react';
import DashBanner from 'primitives/DashBanner/DashBanner';
import { useTranslation } from 'i18n';
import { CameraIconMd } from '@chownow/pantry/icons';

const NS = 'menuManagementMenuContent';

export const PhotoBannerAlert: FunctionComponent = () => {
  const { t } = useTranslation(NS);
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <DashBanner
      icon={<CameraIconMd />}
      isInlineOnMobile
      message={t('PhotoBannerAlert.message')}
      variant="blue"
      withCloseButton
      onClose={() => setDismissed(true)}
    />
  );
};
